import axios from "axios";
import { isEmpty } from "lodash";
// import Cookies from "js-cookie";

const userDetails = localStorage.getItem("sessionUser");
const authUser = localStorage.getItem("authUser");

const userInfo = !isEmpty(userDetails) ? JSON.parse(userDetails) : "";
console.log(userInfo, "userInfo");
console.log(authUser, "authUser");

const userInfoDetails =
  userInfo && userInfo.data && userInfo.data.data
    ? userInfo.data.data.token
    : "";

const axiosInstance = axios.create({
  // baseURL: "https://pmtrewards.mequalsvps.in",
  baseURL: "https://pmtc4.mequalstech.com/api",
  // baseURL: "https://pmtrewards.mequalstech.com/api",

  headers: {
    Accept: "application/json",
    // Authorization: userInfoDetails.token
  },
});
if (userInfoDetails) {
  axiosInstance.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${userInfoDetails}`;
}

// axiosInstance.interceptors.request.use(onRequest, null);

export function setAuthToken(authToken) {
  axiosInstance.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${authToken}`;
}
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default axiosInstance;

export async function get(url, config = {}) {
  return await axiosInstance
    .get(url, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosInstance
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosInstance
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosInstance
    .delete(url, { ...config })
    .then((response) => response.data);
}
